import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Copy, H4 } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import DealerCard from './DealerCard';
import themeStyles from './Shared.styles';
const Title = themeStyles.apply(H4, 'Title');
const DisclaimerText = themeStyles.apply(Copy, 'Disclaimer');
const TitleComponent = () => {
    const { t } = useTranslation();
    return _jsx(Title, { "data-testid": "cy-dealer-locator-title", children: t('Sub-apps.Dealers.dealersInventoryHeading') });
};
const DisclaimerUI = ({ disclaimer }) => (_jsx(DisclaimerText, { size: "regular", "data-testid": "cy-dealer-locator-disclaimer", children: disclaimer }));
export { TitleComponent, DisclaimerUI, DealerCard };
